<!-- vertical layout -->
<!-- <app-vertical *ngIf="isVerticalLayoutRequested()"></app-vertical> -->

<!-- horizontal layout -->
<ng-container *ngIf="{connected: connected$ | async} as obs">
  <app-horizontal [ngClass]="obs.connected ? 'd-block' : 'd-none'"></app-horizontal>
  <div *ngIf="!obs.connected" class="row justify-content-center align-items-center vh-100">
    <div class="col-lg-4">
      <div class="card border border-danger text-center">
        <div class="card-header bg-transparent border-danger">
          <h5 class="my-0 text-danger">Connecting...</h5>
        </div>
        <div class="card-body">
          <i class='bx bx-loader-alt bx-spin text-danger display-4' ></i>
        </div>
      </div>
    </div>
  </div>
</ng-container>


